import { Link } from "react-router-dom";

interface DisclaimerProps {
  compact?: boolean;
  dark?: boolean;
}

const Disclaimer = ({ compact, dark }: DisclaimerProps) => {
  if (compact) {
    return (
      <p className={dark ? "text-xs text-alt-wht/50" : "text-xs text-alt-blk/55"}>
        Night lights are a visual guide, not a Bortle meter. Overnight rules change.{" "}
        <Link
          to="/about"
          className={dark ? "text-ray hover:text-sunset" : "text-turquoise hover:text-mars"}
        >
          About
        </Link>
      </p>
    );
  }

  return (
    <p className="leading-relaxed">
      Curated Bortle classes are typical values, not a measurement from tonight.
      The map overlay is NASA Black Marble night lights — sources of skyglow, not
      a full sky-quality model. Overnight access is not a legal determination.
      Always check the land manager before you stay.
    </p>
  );
};

export default Disclaimer;
